<template>
  <div class="whdAnnularTemp">
    <div
      class="table-responsive whdAnnularTemp-div"
      v-for="(temp, index) in tempData"
    >
      <table class="table whdAnnularTemp-table mb-0">
        <tbody>
          <tr class="whdAnnularTemp-table-row-green stickyHeader">
            <!-- <td style="min-width: 95px; white-space: pre-line" rowspan="2">
              項次/{{ "\n" }}批號+鑄錠編碼
            </td> -->
            <td style="min-width: 4rem">感測點</td>
            <td v-for="data in temp.title">
              {{ data }}
            </td>
          </tr>
          <tr class="whdAnnularTemp-table-row-black stickyHeader">
            <td style="min-width: 4rem">設定值</td>
            <td v-for="data in temp.setValue">
              {{ data }}
            </td>
          </tr>
          <template v-for="(item, key) in temp.data" :keys="key">
            <tr class="">
              <!-- <td
                style="min-width: 95px; white-space: pre-line"
                rowspan="3"
                align="center"
                valign="middle"
              >
                {{ item.title }}
              </td> -->
              <td style="min-width: 4rem; vertical-align: middle" rowspan="2">
                時間
              </td>
              <td v-for="data in item.date" :colspan="data.dateColspan">
                {{ data.date }}
              </td>
            </tr>
            <tr class="">
              <td v-for="data in item.time">
                {{ data }}
              </td>
            </tr>
            <tr class="whdAnnularTemp-table-row-black">
              <td style="min-width: 4rem">實際值</td>
              <td v-for="data in item.actVal">
                {{ data }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tempData: {
      type: Array,
      default: [
        {
          title: ["預熱區", "1區", "2區", "3區", "4區", "出料口"],
          setValue: [1018, 1100, 1180, 1180, 1180, 1200],
          data: [
            {
              title: "1\nSQ0476-21-1",
              date: [
                {
                  date: "2023/04/23",
                  dateColspan: 5,
                },
                {
                  date: "2023/04/24",
                  dateColspan: 1,
                },
              ],
              time: [
                "20:02:00",
                "20:58:16",
                "21:54:48",
                "22:50:22",
                "23:46:32",
                "00:42:46",
              ],
              actVal: [865, 1077, 1200, 1186, 1186, 1198],
            },
            // {
            //   title: "2\nSQ0476-21-2",
            //   date: [
            //     {
            //       date: "2023/04/23",
            //       dateColspan: 5,
            //     },
            //     {
            //       date: "2023/04/24",
            //       dateColspan: 1,
            //     },
            //   ],
            //   time: [
            //     "20:11:54",
            //     "21:07:06",
            //     "22:03:17",
            //     "22:59:03",
            //     "23:55:19",
            //     "00:51:11",
            //   ],
            //   actVal: [865, 1077, 1200, 1186, 1186, 1198],
            // },
            // {
            //   title: "3\nSQ0476-21-3",
            //   date: [
            //     {
            //       date: "2023/04/23",
            //       dateColspan: 4,
            //     },
            //     {
            //       date: "2023/04/24",
            //       dateColspan: 2,
            //     },
            //   ],
            //   time: [
            //     "20:20:23",
            //     "21:16:00",
            //     "22:12:11",
            //     "23:08:24",
            //     "00:04:58",
            //     "01:00:31",
            //   ],
            //   actVal: [865, 1077, 1200, 1186, 1186, 1198],
            // },
            // {
            //   title: "4\nSQ0476-21-4",
            //   date: [
            //     {
            //       date: "2023/04/23",
            //       dateColspan: 4,
            //     },
            //     {
            //       date: "2023/04/24",
            //       dateColspan: 2,
            //     },
            //   ],
            //   time: [
            //     "20:29:58",
            //     "21:25:56",
            //     "22:21:46",
            //     "23:17:27",
            //     "00:13:49",
            //     "01:09:33",
            //   ],
            //   actVal: [865, 1077, 1200, 1186, 1186, 1198],
            // },
          ],
        },
      ],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style scoped>
.whdAnnularTemp-div {
  overflow-y: auto;
  max-height: 630px;
}
.whdAnnularTemp-div .stickyHeader:nth-child(2) {
  top: 44.8px;
}
.whdAnnularTemp-table {
  font-family: "dfyuanstd-w5";
  border-collapse: collapse;
  /* width: 97%; */
}

.whdAnnularTemp-table td {
  width: 5rem;
  height: 2.8rem;
  border: 0.5px solid #999;
  vertical-align: middle;
}

.whdAnnularTemp-table-row-green {
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
}

.whdAnnularTemp-table-row-black {
  background-color: #f2f2f2;
  color: #212529;
  /* font-size: 12px; */
}
</style>
